module.exports = __webpack_public_path__ + "img/document-upload.968c1396.svg";